export default class CMSApiDriveService {
  path = "/api";

  constructor(httpApi) {
    this.httpApi = httpApi;
  }

  async fetchContent(pathApi, params = {}) {
    params.slug = pathApi;
    const config = { ...this.httpApi.getConfig(), params };
    const res = await this.httpApi.get(`${this.path}/cms-content`, config);
    return res.data;
  }

  async menu(params = {}) {
    const config = { ...this.httpApi.getConfig(), params };
    const res = await this.httpApi.get(`${this.path}/infos-et-services/menu`, config);
    return res.data;
  }

  async fetchFuel(id, params = {}) {
    const config = { ...this.httpApi.getConfig(), params };
    const res = await this.httpApi.get(`${this.path}/magasins/${id}/carburants`, config);
    return res.data;
  }
}
